import { useCallback } from 'react';

import { useAnalyticsUtilities } from '@air/analytics';

import META from '~/hooks/events/useTrackInsertCdnLinkBlock.meta';

export type TrackInsertCdnLinkBlockParams = {
  action: 'insert' | 'replace';
  asset_id: string;
  cdn_type: 'imgix' | 'original';
  height: number;
  version: string;
  width: number;
};

export const useTrackInsertCdnLinkBlock = () => {
  const { track } = useAnalyticsUtilities();

  const trackInsertCdnLinkBlock = useCallback(
    (params: TrackInsertCdnLinkBlockParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackInsertCdnLinkBlock };
};
